import React, { useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Container, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import renderField from '../../../shared/components/custom/Field';
import renderDropZoneField from '../../../shared/components/form/DropZoneMS';
import validateSubscriptionPrizeForm from './validateSubscriptionPrizeForm';
import { partial } from '../../../util/translation/translation';
import { getImageHash } from '../../../util/functions';
import TextEditor2 from '../../../shared/components/text-editor/TextEditor2';

const SubscriptionPrizeForm = ({
  subscriptionPrize,
  handleSubmit,
  initialize,
  type,
}) => {
  const s = partial('shared');
  useEffect(() => {
    if (subscriptionPrize) {
      initialize({
        title: subscriptionPrize.title,
        description: subscriptionPrize.description,
        headingImage: {
          name: 'subscription prize image',
          preview: subscriptionPrize.imageUrl,
          croppedImage: subscriptionPrize.imageUrl,
          hash: getImageHash(subscriptionPrize.imageUrl),
        },
      });
    }
  }, [subscriptionPrize]);
  return (
    <form className="form" onSubmit={handleSubmit}>
      <div
        style={{
          backgroundColor: '#F4F4F6',
          borderRadius: 4,
          borderColor: '#D7DAE0',
          borderStyle: 'solid',
          borderWidth: 1,
          marginBottom: 10,
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            borderBottomStyle: 'dashed',
            borderColor: '#D7DAE0',
            padding: '10px 10px 10px 10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: 16,
                lineHeight: '24px',
                color: 'black',
                fontWeight: 'bold',
              }}
            >
              {s('image')}
            </div>
          </div>
        </div>
        <div style={{ padding: '10px' }}>
          <Container>
            <Row>
              <Col md={12}>
                <div className="form__form-group">
                  <Field
                    saveBase64Cropped
                    name="headingImage"
                    maxSize={3}
                    component={renderDropZoneField}
                    displayCrop
                    crop="BANNER_CROP"
                  />
                  <span className="form-header">
                    <strong>{s('note')}:</strong> {s('recommendedImageSize')}{' '}
                    16:9 (1035 x 570 px)
                  </span>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div
        style={{
          backgroundColor: '#F4F4F6',
          borderRadius: 4,
          borderColor: '#D7DAE0',
          borderStyle: 'solid',
          borderWidth: 1,
          marginTop: 10,
          marginBottom: 10,
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            borderBottomStyle: 'dashed',
            borderColor: '#D7DAE0',
            padding: '10px 10px 10px 10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: 16,
                lineHeight: '24px',
                color: 'black',
                fontWeight: 'bold',
              }}
            >
              {s('details')}
            </div>
          </div>
        </div>
        <div style={{ padding: '10px' }}>
          <Container>
            <Row>
              <Col md={12}>
                <div className="form__form-group">
                  <span className="form-header">{s('title')}*</span>
                  <Field
                    name="title"
                    component={renderField}
                    placeholder={s('title')}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form__form-group">
                  <span className="form-header">{s('description')}</span>
                  <div className="marginTop-5" />
                  <div className="form__form-group form__form-group-id">
                    <Field name="description" component={TextEditor2} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Col>
        <Button color="primary">
          {type === 'create' ? `${s('create')}` : `${s('save')}`}
        </Button>
        <Link to={`/goal-sponsor?tab=2`}>
          <Button>{s('close')}</Button>
        </Link>
      </Col>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'subscription_prize_form',
  validate: validateSubscriptionPrizeForm,
});

export default reduxF(SubscriptionPrizeForm);
